import api from "./api";

// Atendimento Nuklie embutido (SDK Embedded). Backend: /api/v1/nuklie — só EMPRESA.

export type NuklieStatus = {
    active: boolean;
    integration_public_identifier: string | null;
    credential_identifier: string | null;
    external_tenant_id: string | null;
    activated_at: string | null;
    sdk_url: string;
};

export type NuklieResource = 'client' | 'plant' | 'proposal' | 'service' | 'requestService';

export type NuklieContextField = { label: string; value: string; type?: 'badge' | 'link'; href?: string };

export type NuklieConversation = {
    contact: { externalId: string; name?: string; phone?: string; email?: string; identifiers?: { platform: string; value: string }[] };
    context: { sections: { title: string; fields: NuklieContextField[] }[] };
};

export async function getNuklieStatus(): Promise<NuklieStatus> {
    const response = await api.get('/nuklie');
    return response.data;
}

export async function activateNuklie(activationCode: string): Promise<NuklieStatus> {
    const response = await api.post('/nuklie/activate', { activation_code: activationCode });
    return response.data;
}

export async function disconnectNuklie(): Promise<void> {
    await api.delete('/nuklie');
}

export async function createNuklieSession(): Promise<string> {
    const response = await api.post('/nuklie/session');
    return response.data.token;
}

export async function getNuklieConversation(resource: NuklieResource, id: string): Promise<NuklieConversation> {
    const response = await api.get(`/nuklie/context/${resource}/${id}`);
    return response.data;
}
